// Статус блокировки филиала из Биллинга.
// Приходит как поле `BillingStatus` в ответах API (общий envelope CRM) и
// читается в едином axios-интерцепторе `setAxiosConfig` — через него проходят
// все слои API (legacy axios, `src/services/rtkQuery`, `src/api`).
// Значения статуса из swagger `CRM.Dots.Billing.ModelBillingStatus.Status`:
// "block" | "unblock" | "pre-block" | "ai-warning". Для фронта значимы
// "block", "pre-block" и "ai-warning"; "unblock"/отсутствие статуса означают
// отсутствие действий.

export type BillingBlockStatus = 'block' | 'pre-block' | 'ai-warning';

type Listener = (status: BillingBlockStatus | null) => void;

const listeners = new Set<Listener>();
let currentStatus: BillingBlockStatus | null = null;

const normalizeBillingStatus = (raw: unknown): BillingBlockStatus | null => {
  if (raw === 'block' || raw === 'pre-block' || raw === 'ai-warning')
    return raw;

  return null;
};

const notify = () => {
  listeners.forEach((fn) => fn(currentStatus));
};

export const billingStatus = {
  get status() {
    return currentStatus;
  },

  setStatus(raw: unknown) {
    const next = normalizeBillingStatus(raw);
    if (next === currentStatus) return;

    currentStatus = next;
    notify();
  },

  subscribe(fn: Listener) {
    listeners.add(fn);

    return () => {
      listeners.delete(fn);
    };
  },
};
